// lodash
import _forEach from 'lodash/forEach';
import _min from 'lodash/min';
import _max from 'lodash/max';
import _sum from 'lodash/sum';
import _reduce from 'lodash/reduce';
import _toString from 'lodash/toString';
import _toInteger from 'lodash/toInteger';
import _toNumber from 'lodash/toNumber';

import ensurePath from '@/helpers/ensureObjectPath';

/**
 * Класс отвечает за работу и форматирование состава корзины
 * @memberof Cart
 * @class
 * @alias Cart.order
 *
 * @param {Instance} _cart - инстанс корзины
 */
var CartOrder = function(_cart) {
  var self = this;
  self._inited = false;

  self._owner = _cart;
};

/**
 * Обновляем состав корзины
 * @method
 * @private
 *
 * @param {Object} order - объект с ответом от платформы
 *
 * @return {Object} WAAT????
 */
CartOrder.prototype.set = function(order) {
  var self = this;

  self._patch(order);

  return self;
};

/**
 * Забираем актуальный состав корзины
 * @method
 *
 * @return {Object} Объект с полным описанием текущего состояния корзины
 */
CartOrder.prototype.get = function() {
  var self = this;

  return self;
};

/**
 * Забираем информацию только о позициях
 * @method
 *
 * @return {Object} Объект вида {variant_id: quantity, ...}
 */
CartOrder.prototype.getItems = function() {
  var self = this;
  var items = {};

  _forEach(self.order_lines, function(item) {
    if (item.accessory_lines && item.accessory_lines.length) {
      items.accessoriable_variant_ids = items.accessoriable_variant_ids || {};

      items.accessoriable_variant_ids[item.variant_id] = items.accessoriable_variant_ids[item.variant_id] || [];

      items.accessoriable_variant_ids[item.variant_id].push({
        quantity: item.quantity,
        accessory_value_ids: item.accessory_value_ids
      });

      return;
    }

    items[item.variant_id] = item.quantity;
  });

  // Если есть склады, то забираем информацию о позициях на каждом складе
  if (self.multi_orders) {
    items.multi_orders = {};

    _forEach(self.multi_orders, function(warehouse, warehouse_id) {
      const warehouseItems = ensurePath(items.multi_orders, [ warehouse_id, 'items' ]);

      _forEach(warehouse.items, function(item) {
        warehouseItems[item.variant_id] = _toNumber(item.quantity);
      });
    });
  }

  return items;
};

/**
 * Забираем комментарии
 * @method
 *
 * @return {Object} Объект вида {variant_id: comment}
 */
CartOrder.prototype.getComments = function() {
  var self = this;

  return self.order_line_comments;
};

CartOrder.prototype._getComments = function(order) {
  var comments = {};

  _forEach(order.items, function(item) {
    comments[item.variant_id] = item.comment;
  });

  return comments;
};

/**
 * Фиксим инфу по корзине
 * @method
 * @private
 *
 * @param {Object} current_order - текущий состав корзины, ответ от платформы
 *
 * @return {void}
 */
CartOrder.prototype._patch = function(current_order) {
  var self = this;

  self.coupon = current_order.coupon;

  self.buildOrderLines(current_order);
  self.buildAccessories(current_order);

  self.order_line_comments = self._getComments(current_order);

  self.positions_count = self.order_lines.length;

  self.items_count = current_order.items_count;

  self.items_price = 0;

  self.total_price = current_order.total_price;

  if (typeof (current_order.sber_bnpl_prices) !== 'undefined') {
    self.sber_bnpl_pay = _min(current_order.sber_bnpl_prices);
    self.sber_bnpl_last_pay = _max(current_order.sber_bnpl_prices);
    self.sber_bnpl_last_pay_info = _sum(current_order.sber_bnpl_prices) - _min(current_order.sber_bnpl_prices);
  }

  if (typeof (current_order.sber_bnpl_dates) !== 'undefined') {
    self.sber_bnpl_first_date = current_order.sber_bnpl_dates[0];
    self.sber_bnpl_second_date = current_order.sber_bnpl_dates[1];
    self.sber_bnpl_third_date = current_order.sber_bnpl_dates[2];
    self.sber_bnpl_fourth_date = current_order.sber_bnpl_dates[3];
  }

  self.discounts = current_order.discounts;

  self.discount_description = current_order.discount_description || null;

  self.errors = current_order.errors || [];

  self._itemsPrice();
  // self._deliveryPrice(current_order);
  self._setId();
  self._images();
  self._getWeight();

  if (!self._inited) {
    self._inited = true;
    EventBus.publish('order_ready:insales:cart', self);
  }

  return;
};

/**
 * Добавляем поле с ценой только товаров, без доставки
 * @method
 * @private
 *
 * @return {void}
 */
CartOrder.prototype._itemsPrice = function() {
  var self = this;

  self.items_price = _reduce(self.order_lines, function(sum, item) {
    return sum + item.sale_price * item.quantity;
  }, 0);

  return;
};

/**
 * Добавляем цену доставки
 * @method
 * @private
 *
 * @todo разрулить момент, что в разных json лежит в разных местах
 * @param {Object} current_order - текущий состав корзины
 *
 * @return {void}
 */
CartOrder.prototype._deliveryPrice = function(current_order) {
  var self = this;
  var delivery_price = _toString(current_order.delivery_price) || _toString(current_order.order.delivery_price);

  self.delivery_price = parseFloat(delivery_price);

  return;
};

/**
 * Вытаскиваем наружу id
 * @method
 * @private
 *
 * @return {void}
 */
CartOrder.prototype._setId = function() {
  var self = this;

  _forEach(self.order_lines, function(item) {
    item.id = item.variant_id; // eslint-disable-line id-length
  });

  return;
};

/**
 * @description
 * Фиксим картинки товаров
 *
 * @method
 * @private
 *
 * @return {void}
 */
CartOrder.prototype._images = function() {
  var self = this;

  _forEach(self.order_lines, function(item) {
    var image = (typeof item.images != 'undefined') ? item.images[0] : {};
    item.first_image = item.first_image || image || {};
    item.images = (item.product && typeof item.product.images != 'undefined') ? item.product.images : item.images;
  });

  return;
};

/**
 * @description
 * Вычисляем вес позиции
 *
 * @return {void}
 */
CartOrder.prototype._getWeight = function() {
  var self = this;

  self.items_weight = _reduce(self.order_lines, function(_totalWeight, item) {
    return _totalWeight + item.weight * item.quantity;
  }, 0);

  return;
};

/**
 * Достаём информацию о позиции по ID.
 * @method
 *
 * @param {Number} variantId - id варианта
 * @param {Boolean} [withAccessories=false] - флаг, если нужно учитывать опции
 *
 * @return {Object|Array} Объект с подробной информацией о конкретной позиции в корзине или массив с объектами, если есть опции и мы передали флаг
 */
CartOrder.prototype.getItemByID = function(variantId, withAccessories = false) {
  const self = this;
  const _id = _toInteger(variantId);

  // Если order_lines ещё не готовы. undefined потому что до этого возвращался именно он, а мы не хотим кому-нибудь сломать код
  if (!self.order_lines || !self.order_lines.length) {
    return withAccessories ? [] : undefined;
  }

  // Фильтруем order_lines по ID
  const filteredItems = self.order_lines.filter(item => item.id === _id);

  // Если флаг withAccessories не установлен, то возвращаем найденный айтем
  if (!withAccessories) {
    return filteredItems[0];
  }

  // Возвращаем массив элементов, если флаг установлен и элементов больше одного
  return filteredItems;
};

/**
 * Если есть мультисклады, то забираем информацию о позициях на каждом складе и добавляем её в order_lines
 * @method
 *
 * @param {number} current_order - текущий состав корзины, ответ от платформы
 *
 * @return {void}
 */

CartOrder.prototype.buildOrderLines = function(current_order) {
  const self = this;

  if (!current_order.multi_orders) {
    self.order_lines = current_order.items;

    return;
  }

  self.order_lines = [];
  let addedItems = {};

  // Создаем словарь для быстрого доступа к элементам
  const current_order_items = current_order.items.reduce((acc, item) => {
    acc[item.variant_id] = item;

    return acc;
  }, {});

  for (let warehouse of Object.values(current_order.multi_orders)) {
    for (let itemId in warehouse.items) {
      if (current_order_items[itemId]) {
        if (addedItems[itemId]) {
          // Обновляем остатки товара, если он уже был добавлен в order_lines
          addedItems[itemId].quantity += warehouse.items[itemId].quantity;
        } else {
          // Добавляем товар, если он еще не был добавлен
          const warehouse_item = Object.assign({}, current_order_items[itemId], warehouse.items[itemId]);
          self.order_lines.push(warehouse_item);

          // Сохраняем ссылку на объект товара, чтобы обновлять его остатки при изменении количества
          addedItems[itemId] = warehouse_item;
        }
      }
    }
  }

  return;
};

CartOrder.prototype.buildAccessories = function(current_order) {
  const self = this;

  if (current_order.multi_orders) {
    return;
  }

  self.order_lines.forEach(order_line => {
    if (!order_line.accessory_lines.length) {
      return;
    }

    order_line.accessory_value_ids = {};
    order_line.accessories_price = 0;

    order_line.accessory_lines.forEach(accessory => {
      order_line.accessory_value_ids[accessory.accessory_value_id] = 1;
      order_line.accessories_price += Number(accessory.price);
    });
  });
};

export default CartOrder;
